// Things related to the shared shene page
const SharedScene = {
	// group ID of the sharing group, the group whose id is in the url
	// This is not the same as the group the user might be in
	sharingGroupID : null, 
	makeNewSceneSharingCodeAndUpdateInUI : async (grid) => {
		let result = await Cloud.getNewInviteCode(grid, 1); // Usage code here is 1, because it's a share group
		if (result.success) CP.getel('inviteCodeText').textContent = result.inviteCode;
		else CP.showErrorMessage("Failed to get scene sharing code!");
	},
	sceneSharingButtonClicked : async () => {
		if (SharedScene.sharingGroupID) {
			SharedScene.makeNewSceneSharingCodeAndUpdateInUI(SharedScene.sharingGroupID);
		} else
			// This should probably not happen
			CP.showErrorMessage("Can't make scene sharing code because group ID is missing!");
	},
	getSceneAndUpdatePage : async (grid) => {
		// Assume current version since scenes are not available in version 0
		// TBD : Might want to review later how we get the version here
		let indexRes = await Cloud.getIndexFromCloud({ groupID: grid, version : Constants.CurrentVersion});
		let sceneEntry = null;
		let sceneEntryKey = null;
		let indexFile = null;
		if (indexRes.success) {
			indexFile = indexRes.indexFile;
			// Find the first entry that is a scene entry
			for(const key in indexFile.Entries) {
				let entry = indexFile.Entries[key];
				if (entry.File?.ArkioScene != null) {
					sceneEntry = entry;
					sceneEntryKey = key;
					CP.getel('sceneName').textContent = Util.getFilenameWithoutExtension(sceneEntry.File.Filename);
					break;
				}
			}
		}

		let sharedSceneDiv = CP.getel('sharedSceneDiv');

		if (sceneEntry) {
			CP.showEl(sharedSceneDiv);
			let textBubbleArea = CP.MsgManager.staticMsgArea;
			let newToArkioMessage = CP.getel('newToArkioMessage');
			CP.showEl(CP.getel('sceenSharingCodeButton'));
			SharedScene.makeNewSceneSharingCodeAndUpdateInUI(grid);
			let sceneSaveInfoDiv = CP.getel('sceneSaveInfoDiv');
			if (CP.isLinked()) {
				CP.hideEl(newToArkioMessage);
				let textBubble1 = new CP.TextBubble(textBubbleArea, "", CP.TextBubbleStyle.Simple, null, false);
				textBubble1.setText(CP.getel('linkedMessage1').innerHTML, true);
				// If connected to a group then enable saving the scene to that group.
				let sceneSaveButton = CP.getel('sceneSaveButton');
				sceneSaveButton.onclick = () => CP.saveSharedItemToUserGroup({ entryHash: sceneEntryKey, entryValue: sceneEntry }, 'Scene');
				CP.showEl(sceneSaveButton);
				CP.showEl(sceneSaveInfoDiv);
			} else {
				let textBubble2 = new CP.TextBubble(textBubbleArea, "", CP.TextBubbleStyle.Simple, null, false);
				textBubble2.setText(CP.getel('unlinkedMessage1').innerHTML, true);
				CP.showEl(newToArkioMessage);
				CP.hideEl(sceneSaveInfoDiv);
			}
		} else {
			CP.hideEl(sharedSceneDiv);
			let textBubble1 = new CP.TextBubble(CP.MsgManager.errorArea, "It looks like the file you're trying to access is no longer available. Please ask the sender to share a new link with you.", CP.TextBubbleStyle.Error, null, false);
		}
	}
};

CP.setupSharedPage(SharedScene, {
    listItemId: 'sharedSceneListItem',
    updatePage: SharedScene.getSceneAndUpdatePage,
    messageAreasContainerId: 'messageAreas',
    onDOMContentLoaded: () => {
        CP.setupCopyInviteCodeButton('copyButtonSpan', 'inviteCodeText', {
            copying: "Copying scene sharing code",
            copied: "Scene sharing code"
        });
    }
});
